import { doc } from "firebase/firestore"
import { requireDb } from "../_core/db"
import { requireBranchContext } from "../_core/context"

export const settingsGeneralDoc = (db, ctx) =>
    doc(db, "tenants", ctx.idTenant, "branches", ctx.idBranch, "settings", "general")

export const getContext = (ctxOverride) => {
    if (ctxOverride) return ctxOverride
    return requireBranchContext()
}

export const getDb = () => requireDb()
